import cn from 'classnames';
import { FC, ReactNode, useState } from 'react';
import { ChevronDownIcon } from '../../assets/svg/chevron-down';
import { Tooltip } from '../../features/tooltip/tooltip';
import { useLang } from '../../hooks/use-lang';
import { Button } from '../button/button';
import { Loader } from '../loader/loader';
import s from './dropdown.module.css';

export type DropdownOptionType = {
  key: string;
  label: ReactNode;
  content?: ReactNode;
  isActive?: boolean;
  isLoading?: boolean;
  onClick?: (value: string) => void;
};

interface Props {
  label?: ReactNode;
  options: DropdownOptionType[];
  leftIcon?: ReactNode;
  className?: string;
  optionsClassName?: string;
  withReset?: boolean;
  highlightTriggerOnly?: boolean;
  closeOnSelect?: boolean;
  withChevron?: boolean;
  onReset?: () => void;
}

export const Dropdown: FC<Props> = (props) => {
  const {
    label,
    options,
    leftIcon,
    className,
    optionsClassName,
    withReset,
    highlightTriggerOnly,
    closeOnSelect,
    withChevron = true,
    onReset,
  } = props;
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  return (
    <Tooltip
      offset={12}
      wrapperClassName={cn(s.feature, className)}
      optionsWrapperClassName={cn(s.options, optionsClassName)}
      open={open}
      onOpen={setOpen}
      trigger={
        <div role="button" className={s.button}>
          <span className={cn(s.leftIcon, options.some((o) => o.isActive) && s.activeFilter)}>
            {leftIcon}
          </span>
          {label && <span className="hide__M hide__S">{label}</span>}
          {withChevron && (
            <ChevronDownIcon className={cn(s.chevron, open && s.open, 'hide__M hide__S')} />
          )}
        </div>
      }
    >
      <ul className={s.list}>
        {options.map(({ key, label, content, isActive, isLoading, onClick }) => {
          const handleSelect = () => {
            if (closeOnSelect) {
              setOpen(false);
            }
            onClick?.(key);
          };

          return (
            <li key={`${key}-${label}`} className={s.item} onClick={handleSelect}>
              <div className={cn(s.label, !highlightTriggerOnly && isActive && s.activeFilter)}>
                {label}
                {isLoading && <Loader />}
              </div>
              {content}
            </li>
          );
        })}
      </ul>

      {withReset && onReset && (
        <div className={s.resetBtn}>
          <Button variant="secondary" onClick={onReset}>
            {t('Сбросить')}
          </Button>
        </div>
      )}
    </Tooltip>
  );
};
